import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import ProductPreview from '../../../../products/components/product_preview/ProductPreview';
import { productsActions } from '../../../../products/actions';
import styles from './Products.module.sass';
import { productsObjectsSelector } from '../../../../products/selectors/products';
import api from '../../../../products/api';
import ProductsSlider from '../../../../product/components/products_slider/ProductsSlider';

const MAX_PRODUCTS_COUNT = 3;

function Products(props) {
  const loadedProductsRef = useRef(false);
  const {
    productIds, addProducts, products: allProducts, addToBag,
  } = props;

  useEffect(() => {
    if (productIds.length === 0 || loadedProductsRef.current) {
      return;
    }

    api.loadProductsByIds(productIds).then((response) => {
      addProducts(response.data);
      loadedProductsRef.current = true;
    });
  }, []);

  const productsById = allProducts.reduce((acc, product) => {
    acc[product.id] = product;
    return acc;
  }, {});

  const products = productIds.flatMap((id) => (productsById[id] ? [productsById[id]] : []));

  if (products.length === 0) { return null; }

  return (
    <div className={styles['products-wrapper']}>
      <div className={styles.content}>
        <div className={styles.title}>
          Shop This Post
        </div>
        { products.length <= MAX_PRODUCTS_COUNT ? (
          <div className={styles.products}>
            {products.map((product) => (
              <ProductPreview
                key={product.id}
                product={product}
                addToBag={addToBag}
                className={styles['product-preview']}
                buttonColor="black"
              />
            ))}
          </div>
        ) : <ProductsSlider products={products} addToBag={addToBag} />}
      </div>
    </div>
  );
}

Products.propTypes = {
  addToBag: PropTypes.func.isRequired,
  addProducts: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  productIds: PropTypes.arrayOf(PropTypes.number).isRequired,
};

const mapStateToProps = (state) => ({
  products: productsObjectsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  addToBag: (id) => dispatch(productsActions.addToBagRequest(id)),
  addProducts: (products) => dispatch(productsActions.addProducts(products)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Products);
